import React, { useState, useEffect, useRef, Component } from 'react';
import {useSelector, useDispatch} from 'react-redux';

import Track from './Track.js';
import spotify_logo from './spotify.svg'

import SearchIcon from '@mui/icons-material/Search';

import Toast from './Toast';

import db from './firebase.config.js';
import { sessionDocRef } from './sessionId.js';
import firebase from 'firebase/app';
import "firebase/firestore";
import './main.css'

import { useCookies } from 'react-cookie';
import DragTable from './DragTable.js';
import useCountdown from './useCountdown';
import { passengerLabel } from './Passengers';

import GraphModal from './GraphModal.js';

const QUEUE_COOLDOWN_MS = 60000;
const SEARCH_DEBOUNCE_MS = 200;
const spotifyToken = value => typeof value === 'string' && value.trim() && value !== 'NO_ACCESS' ? value.trim() : null;
const currentSpotifyTrackId = value => typeof value === 'string'
  ? value.match(/(?:spotify:track:|\/track\/)([^/?#]+)/)?.[1] || '' : '';
const readQueueDeadline = key => {
  try {
    const value = Number(sessionStorage.getItem(key));
    return Number.isFinite(value) && value > 0 ? value : 0;
  } catch { return 0; }
};
const storeQueueDeadline = (key, deadline) => {
  try {
    if (deadline) sessionStorage.setItem(key, String(deadline));
    else sessionStorage.removeItem(key);
  } catch { /* Storage is optional; the mounted guard still applies. */ }
};

// Search results list (dark themed)
class ResultsList extends Component {
    render() {
      const { results, focus } = this.props;
      return (
        <ul id="queue-search-results" aria-label="Song search results" className="add-to-queue__search-results">
          <style>{`
            .add-to-queue__search-results {
              list-style: none;
              margin: 0;
              padding: 0;
              background: #16161a;
              border-radius: 12px;
              margin-top: 4px;
              max-height: 240px;
              overflow-y: auto;
            }
            .add-to-queue__search-results-item {
              padding: 8px 12px;
              border-bottom: 1px solid rgba(255,255,255,0.04);
            }
            .add-to-queue__search-results-item--focused {
              background-color: #24242c;
            }
            .container{
              display: flex;
              align-items: center;
              gap: 10px;
            }
            .album-img{
                width: 40px;
                height: 40px;
                flex-shrink: 0;
            }
            .album-img img {
                width: 40px;
                height: 40px;
                border-radius: 8px;
                object-fit: cover;
            }
            .flex-item{
                flex-grow: 1;
                min-width: 0;
            }
            .song-name {
              font-size: 14px;
              font-weight: 600;
              margin-bottom: 2px;
              color: #f0f0f2;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .flex-item > div:last-child {
              font-size: 12px;
              color: rgba(240,240,242,0.6);
            }
          `}</style>
          {results.map((r, index) => {
            const isFocused = focus === index;
            const className =
              'add-to-queue__search-results-item' + (isFocused ? ' add-to-queue__search-results-item--focused' : '');
              return (
              <li key={r.id} data-search-index={index} className={className}><button type="button" className="search-result-button" onMouseDown={event => event.preventDefault()} onFocus={() => this.props.onFocus(index)} onClick={() => this.props.onSelect(r)} aria-label={`Add ${r.name} to the queue`}>
                <div className="container">
                  <div className="album-img">
                    <img src={r.album?.images?.[2]?.url || r.album?.images?.[0]?.url || spotify_logo} alt=""/>
                  </div>
                  <div className="flex-item">
                    <div className="song-name">{r.name}</div>
                    <div>{r.artists?.[0]?.name || 'Unknown artist'}</div>
                  </div>
                  <span className="search-result-add" aria-hidden="true">+</span>
                </div>
              </button></li>
            );
          })}
        </ul>
      );
    }
}

// Queue list (dark themed)
class QueueList extends Component {
    render() {
      const { results, focus } = this.props;
      return (
        <ul className="add-to-queue__search-results">
          <style>{`
            .add-to-queue__search-results {
              list-style: none;
              margin: 0;
              padding: 0;
              max-height: 21vh;
              overflow-y: scroll;
            }
            .actual-queue-item {
              padding: 2px 0;
            }
            .flex-item{
                flex-grow: 1;
            }
          `}</style>
          {results && results.map((track, index) => {
            const r=track['track_id']
            const pax_id=track['pax_id']
            return (
              <li key={`${pax_id}-${r}-${index}`}>
                  <div className="flex-item">
                      <div>
                        <Track
                          track_id={track.track_id}
                          artist={track.artist}
                          song_name={track.track_name}
                          url={track.url}
                          cover_art={track.cover_art}
                          driver={track.driver_uid}
                          passenger={this.props.passenger}
                          queuedBy={passengerLabel(this.props.live_pax, this.props.passenger, pax_id)}
                          index={index}
                          genres={["Fan Picked"]}
                          bot={true}
                          meta={track.meta ? track.meta : {}}
                          />
                      </div>
                  </div>
              </li>
            );
          })}
        </ul>
      );
    }
}


export default function Genres(props){
  const uid = props.uid
  const start = props.start
  const pax = props.passenger
  const queue_control = props.queue_control
  const vol_control = props.vol_control
  const dispatch = useDispatch();

  const idx = props.idx
  const queued_idx = props.queued_idx
  const pax_prefs = useSelector(state=>state.preferences)
  const selectedGenres = [...new Set((Array.isArray(pax_prefs) ? pax_prefs : []).filter(genre => typeof genre === 'string' && genre.trim()))];
  const genreNames = selectedGenres.map(genre => {
    if (['r&b', 'edm'].includes(genre.toLowerCase())) return genre.toUpperCase();
    return genre.charAt(0).toUpperCase() + genre.slice(1);
  });
  const genreSummary = genreNames.length ? genreNames.slice(0, 2).join(', ') : 'Choose your genres';
  const pax_prefs_change = useSelector(state=>state.preferences_change)
  const redux_pax_queue = useSelector(state=>state.pax_queue)
  const currentTrackUrl = useSelector(state=>state.url)

  const db_circ_delay = props.circle_delay
  const sesh_id = useSelector(state => state.session_id)

  const [pulseOpen, setPulseOpen] = useState(false);
  const [open_toast, setOpen] = useState(false);
  const [open_same_song_toast, setSameSongOpen] = useState(false);

  const [request_sent, set_request_sent] = useState("none")
  const [queue, setQueue] = useState({})
  const [flat_queue, setFlatQueue] = useState([])
  const [results, setResults] = useState([])
  const [text, setText] = useState("")
  const [focus, setFocus] = useState(-1)
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchState, setSearchState] = useState('idle');
  const searchContainer = useRef(null);
  const searchTimer = useRef(null);
  const cooldownKey = `strive:queue:${uid}:${start}:${pax}`;
  const [queueCooldown, setQueueCooldown] = useState(() => ({ key: cooldownKey, deadline: readQueueDeadline(cooldownKey) }));
  const queueDeadline = queueCooldown.key === cooldownKey ? queueCooldown.deadline : 0;
  const cooldownRef = useRef(queueCooldown);
  const activeScope = useRef(cooldownKey);
  activeScope.current = cooldownKey;
  const observedCooldown = useRef({ key: null, delayed: false });
  const mounted = useRef(true);
  const secondsRemaining = useCountdown(queueDeadline);
  const circle_delay = secondsRemaining > 0;
  const [adding, setAdding] = useState(false);
  const [queueError, setQueueError] = useState('');
  const queueInFlight = useRef(null);
  const searchRequest = useRef(0);
  const dismissSearch = () => {
    clearTimeout(searchTimer.current);
    searchRequest.current += 1;
    setSearchOpen(false); setSearchState('idle'); setResults([]); setFocus(-1);
  };

  const applyDeadline = (key, deadline) => {
    cooldownRef.current = { key, deadline };
    setQueueCooldown({ key, deadline });
  };

  const [cookies, setCookie] = useCookies(['user']);

  const driver_access = props.driver_access
  const pax_access = props.pax_access

  const docExists = async (docName, docId) => (await db.collection(docName).doc(docId).get()).exists
  const deepDocExists = async (docName, docId, docName2, docId2) => (await db.collection(docName).doc(docId).collection(docName2).doc(docId2).get()).exists

  const update_driver_queue = async (track, pax_id) => {
    if(uid && pax_id && start != null && start !== '' && start !== -1 && idx != null && idx !== -1){
      const queued_at = firebase.firestore.Timestamp.now()
      track['queued_at'] = queued_at
      var pax_key = 'pax_queue.'+pax_id
      await db.collection('Users').doc(uid).update({
          [pax_key]: firebase.firestore.FieldValue.arrayUnion(track),
          ['live_pax_coords.'+pax_id+'.queue_delay']: true,
          last_queued_song: track.track_id,
        })

      var pax_tracks_doc = pax_id+"_"+track.track_id
      var tmp_tr_name = track.track_id + "_" + (queued_idx)
      console.log('updating pax_queue for ' + uid + ' with track ' + track.track_id + " with pax_doc " + pax_tracks_doc + " with sesh start " + start)

      const sessionRef = sessionDocRef(db, uid, start)
      if (sessionRef) sessionRef.collection('pax_tracks').doc(String(tmp_tr_name)).set(track, {merge: true}).catch(() => { /* Queue already saved; analytics must not duplicate it. */ })
    }else{
      throw new Error('The ride is not ready for song requests.');
    }
  }

  const update_pax_interactions = async (track, pax) => {
    try{
      if (await deepDocExists("Passengers", pax, "sessions", sesh_id)) {
              const unix_rn = Date.now() / 1000
              await Promise.all([db.collection('Passengers').doc(pax).update({
                'last_used' : firebase.firestore.FieldValue.serverTimestamp(),
              }),
              db.collection('Passengers').doc(pax).collection("sessions").doc(sesh_id).update({
                  'actions':firebase.firestore.FieldValue.arrayUnion('queued_track'),
                  'interactions': firebase.firestore.FieldValue.arrayUnion({
                      'action' : 'queued_track',
                      'meta' : track,
                      'time' : unix_rn
                  }),
              })]);
      }
    }catch (e) {
      console.log("failed adding queue interaction ")
    }
  }

  const handleChange = e => {
      const text = e.target.value;
      setText(text)
      if (text.trim() && queue_control) {
          searchTracks(text)
      } else {
          dismissSearch();
          setQueueError('');
      }
  };

  const handleSelectElement = async track => {
    const deadline = cooldownRef.current.key === cooldownKey ? cooldownRef.current.deadline : 0;
    if (queueInFlight.current?.key === cooldownKey || Date.now() < Math.max(deadline, readQueueDeadline(cooldownKey))) return;
    if (!queue_control) { setOpen(true); return; }
    if (!track) return;
    // The legacy last_queued_song marker survives rides. Only the actual queue
    // tail (or current song for an empty queue) can establish a repeat now.
    const pendingTracks = Object.values(redux_pax_queue || {}).filter(Array.isArray).flat()
      .filter(item => item && typeof item.track_id === 'string')
      .sort((a, b) => (a.queued_at?.toMillis?.() || 0) - (b.queued_at?.toMillis?.() || 0));
    const previousTrackId = pendingTracks.length
      ? pendingTracks[pendingTracks.length - 1].track_id : currentSpotifyTrackId(currentTrackUrl);
    if (track.id === previousTrackId) { setSameSongOpen(true); return; }
    const request = { key: cooldownKey };
    const isCurrent = () => mounted.current && activeScope.current === request.key && queueInFlight.current === request;
    queueInFlight.current = request; setAdding(true); setQueueError('');
    clearTimeout(searchTimer.current); searchRequest.current += 1; setSearchState('idle');
    try {
      const track_obj = {
        track_id: track.id, track_name: track.name, artist: track.artists?.[0]?.name || '',
        cover_art: track.album?.images?.[2]?.url || track.album?.images?.[0]?.url || '',
        url: `https://open.spotify.com/track/${track.id}?utm_campaign=com.app`,
        pax_id: pax, driver_uid: uid,
      };
      await update_driver_queue(track_obj, pax);
      const until = Date.now() + QUEUE_COOLDOWN_MS;
      storeQueueDeadline(request.key, until);
      update_pax_interactions(track_obj, pax);
      if (!isCurrent()) return;
      applyDeadline(request.key, until);
      dismissSearch();
      setText(''); setResults([]); setFocus(-1);
    } catch { if (isCurrent()) setQueueError('Couldn’t add that song. Please try again.'); }
    finally { if (isCurrent()) { queueInFlight.current = null; setAdding(false); } }
  };

  const handleFocus = e => { if (e.target.value.trim() && queue_control && !adding) searchTracks(e.target.value); };
  const handleKeyDown = e => {
    if (e.key === 'Escape') { e.preventDefault(); setText(''); dismissSearch(); return; }
    if (e.target.tagName !== 'INPUT' || e.nativeEvent.isComposing || !searchOpen) return;
    if (e.key === 'ArrowUp') { e.preventDefault(); setFocus(previous => Math.max(0, previous - 1)); }
    if (e.key === 'ArrowDown') { e.preventDefault(); setFocus(previous => Math.min(results.length - 1, previous + 1)); }
    if (e.key === 'Enter' && results.length) { e.preventDefault(); handleSelectElement(results[Math.max(0, focus)]); }
  };

  const SPOTIFY_API_BASE = 'https://api.spotify.com/v1';

  const searchTracks = (query) => {
      clearTimeout(searchTimer.current);
      const requestId = ++searchRequest.current;
      const scope = cooldownKey;
      const isCurrent = () => mounted.current && activeScope.current === scope && requestId === searchRequest.current;
      setQueueError(''); setResults([]); setFocus(-1); setSearchOpen(true); setSearchState('loading');
      searchTimer.current = setTimeout(async () => {
        if (!isCurrent()) return;
        const passengerToken = spotifyToken(pax_access);
        const driverToken = spotifyToken(driver_access);
        const token = passengerToken || driverToken;
        if (!token) {
          setSearchState('error'); setQueueError('Search is connecting. Try again in a moment.'); return;
        }
        const queryUrl = `${SPOTIFY_API_BASE}/search?q=${encodeURIComponent(query.trim())}&type=track&limit=10`;
        const request = accessToken => fetch(queryUrl, { method: 'GET', headers: { Authorization: `Bearer ${accessToken}` } });
        try {
          let result = await request(token);
          // An expired passenger login should not prevent guest search using
          // the driver's existing catalog access. Retry only authentication failure.
          if (isCurrent() && result.status === 401 && passengerToken && driverToken && driverToken !== passengerToken) {
            result = await request(driverToken);
          }
          if (!isCurrent()) return;
          if (!result.ok) throw new Error('Search failed');
          const data = await result.json();
          if (!Array.isArray(data?.tracks?.items)) throw new Error('Invalid search response');
          if (isCurrent()) {
            setResults(data.tracks.items.filter(item => item && typeof item.id === 'string' && typeof item.name === 'string'));
            setSearchState('ready');
          }
        } catch {
          if (isCurrent()) { setSearchState('error'); setQueueError('Search is unavailable. Try again.'); }
        }
      }, SEARCH_DEBOUNCE_MS);
    };

  function sendPreferences(){
      db.collection('Users').doc(uid).update({
          passengerPreferences: pax_prefs,
          passengerRequest: "sent",
      }, {merge: true})
      set_request_sent("sent");
  }

  useEffect(()=>{
    if(pax_prefs_change){
      const timer = setTimeout(()=>{
        dispatch({type: 'Pax_Prefs_Changed', payload: {preferences_change: false}})
      }, 2000)
      return () => clearTimeout(timer);
    }
  }, [pax_prefs_change, dispatch])

  useEffect(()=>{
    if(queue && typeof queue === 'object'){
      var flattened = []
      for (const [tmp_pax, tmp_queue] of Object.entries(queue)){
        if (Array.isArray(tmp_queue)) flattened = flattened.concat(tmp_queue)
      }
      flattened.sort((a,b) => (a.queued_at?.toMillis?.() || 0) - (b.queued_at?.toMillis?.() || 0));
      setFlatQueue(flat_queue => [...flattened])
    }
  }, [queue])

  useEffect(()=>{
    if(redux_pax_queue != []){
      setQueue(redux_pax_queue)
    }
  }, [redux_pax_queue])

  useEffect(() => {
      if(uid!=""){
          return db.collection('Users').doc(uid).onSnapshot(snapshot => {
              if (snapshot.exists) set_request_sent(String(snapshot.data().passengerRequest));
          })
      }
  }, [uid])

  useEffect(() => {
    mounted.current = true;
    const outside = event => { if (!searchContainer.current?.contains(event.target)) dismissSearch(); };
    document.addEventListener('pointerdown', outside);
    return () => {
      mounted.current = false; searchRequest.current += 1; clearTimeout(searchTimer.current);
      document.removeEventListener('pointerdown', outside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!queue_control || circle_delay) dismissSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queue_control, circle_delay]);

  useEffect(() => {
    searchContainer.current?.querySelector(`[data-search-index="${focus}"]`)?.scrollIntoView?.({ block: 'nearest' });
  }, [focus]);

  useEffect(() => {
    const previous = observedCooldown.current;
    const scopeChanged = previous.key !== cooldownKey;
    const rising = db_circ_delay && (scopeChanged || !previous.delayed);
    observedCooldown.current = { key: cooldownKey, delayed: Boolean(db_circ_delay) };
    if (scopeChanged) {
      queueInFlight.current = null;
      dismissSearch();
      setAdding(false); setText(''); setResults([]); setFocus(-1); setQueueError('');
      const existing = readQueueDeadline(cooldownKey);
      // Preserve an elapsed stored deadline long enough for its timer to clear
      // the native boolean, rather than starting another minute on remount.
      const deadline = existing || (db_circ_delay ? Date.now() + QUEUE_COOLDOWN_MS : 0);
      applyDeadline(cooldownKey, deadline);
      storeQueueDeadline(cooldownKey, deadline);
    } else if (rising && !queueInFlight.current) {
      // A later request in another tab can set the native boolean again.
      // No timestamp exists in that schema, so resume with a bounded minute.
      const existing = readQueueDeadline(cooldownKey);
      const deadline = existing > Date.now() ? existing : Date.now() + QUEUE_COOLDOWN_MS;
      applyDeadline(cooldownKey, deadline);
      storeQueueDeadline(cooldownKey, deadline);
    }
    // Local pending writes emit optimistic snapshots. They must not start a
    // cooldown until the awaited queue write succeeds.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [db_circ_delay, cooldownKey]);

  useEffect(() => {
    if (!queueDeadline) return;
    const scope = cooldownKey;
    const timer = setTimeout(() => {
      if (activeScope.current !== scope || cooldownRef.current.deadline !== queueDeadline) return;
      storeQueueDeadline(scope, 0);
      applyDeadline(scope, 0);
      if (uid && pax) db.collection('Users').doc(uid).update({
        ['live_pax_coords.'+pax+'.queue_delay']: false,
      }).catch(() => { if (mounted.current && activeScope.current === scope) setQueueError('Couldn’t sync the queue timer. Please retry.'); });
    }, Math.max(0, queueDeadline - Date.now()));
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queueDeadline, cooldownKey, uid, pax]);

  const handle_disabled_queue_close = (event, reason) => {
      if (reason === 'clickaway') return;
      setOpen(false);
    };

  const handle_same_song_close = (event, reason) => {
      if (reason === 'clickaway') return;
      setSameSongOpen(false);
    };

  return (
    <div className='genre_div'>
          <Toast
              open={open_toast}
              autoHideDuration={2000}
              onClose={handle_disabled_queue_close}
              message="Ask Striver to re-enable Queueing in Strive settings."
          />
          <Toast
              open={open_same_song_toast}
              autoHideDuration={10000}
              onClose={handle_same_song_close}
              message="Choose another song before repeating this one."
          />

        {/* Pulse toggle + Search bar */}
        <div ref={searchContainer} onKeyDown={handleKeyDown} onBlur={event => {
          if (event.relatedTarget && !event.currentTarget.contains(event.relatedTarget)) dismissSearch();
        }}>
        <div className='request_song'>
          <div className='dark-search-bar'>
            <SearchIcon style={{ color: 'rgba(240,240,242,0.35)', fontSize: '18px' }} />
            {circle_delay ?
              <span className="queue-countdown" role="timer">Add another song in <strong>{secondsRemaining}s</strong></span>
              :
              <input
                type="text"
                placeholder={queue_control ? "Search for a song or artist" : "Your driver has paused song requests"}
                aria-label="Search songs and artists"
                aria-controls={searchOpen ? 'queue-search-results' : undefined}
                autoComplete="off"
                disabled={!queue_control || adding}
                value={text}
                onChange={handleChange}
                onFocus={handleFocus}
              />
            }
          </div>
        </div>

        {queueError && <p className="error-text" role="alert">{queueError}</p>}
        {adding && <p className="queue-countdown" role="status">Adding your song…</p>}
        {/* Search results */}
        {queue_control && !circle_delay && !adding && searchOpen && <>
          {searchState === 'loading' && <p className="queue-countdown" role="status">Searching…</p>}
          {searchState === 'ready' && results.length === 0 && <p className="queue-countdown" role="status">No songs found. Try another song or artist.</p>}
          {results.length > 0 && <ResultsList results={results} onSelect={handleSelectElement} onFocus={setFocus} focus={focus} />}
        </>}
        </div>

        <button className="taste-disclosure" onClick={() => setPulseOpen(!pulseOpen)} aria-expanded={pulseOpen} aria-controls="ride-taste" aria-label={`Edit genres. ${genreNames.length ? `Selected: ${genreNames.join(', ')}` : 'No genres selected'}`} title={genreNames.join(', ')}><span className="taste-summary"><span className="taste-icon" aria-hidden="true">♫</span><span className="taste-selected">{genreSummary}</span>{genreNames.length > 2 && <span className="taste-overflow">+{genreNames.length - 2}</span>}</span><span className="taste-action">Edit <span aria-hidden="true">{pulseOpen ? '−' : '+'}</span></span></button>
        {/* Genre Pulse Card (toggleable) */}
        {pulseOpen && (
          <div id="ride-taste"><GraphModal
            live_pax={props.live_pax}
            uid={uid}
            pax={pax}
            sesh_id={sesh_id}
          /></div>
        )}

        {/* Queued songs */}
        <div className='upcoming_queue'>
            {flat_queue && flat_queue.length > 0 &&
            <>
              <div className='section-header'>
                <span className='section-header-label queued'>Passenger picks</span>
                <span style={{ fontSize: '10px', color: 'rgba(240,240,242,0.35)', background: '#24242c', padding: '1px 6px', borderRadius: '9999px' }}>{flat_queue.length}</span>
                <div className='section-header-line' />
              </div>
              <QueueList results={flat_queue} focus={focus} passenger={pax} live_pax={props.live_pax} />
            </>
            }

            {/* Up Next section */}
            <div className='section-header'>
              <span className='section-header-label'>The ride mix</span>
              <div className='section-header-line' />
            </div>
            <DragTable uid={uid} active={true} pax_proximity={true} pax={pax} start={start} idx={idx} queued_idx={queued_idx}/>
        </div>
    </div>
  )
}
